<template>

    <header>

    <a id="toggle-nav" @click="openMenu">
      <span></span>
      <div v-if="badgeCount > 0" class="indicator">
        <div class="noti_count" role="status">{{ badgeCount }}</div>
      </div>
    </a>

    <span v-if="$route.name === 'home'">
        <span class="logo"></span>
    </span>

    <h1 v-if="$route.name !== 'home'">
      <i :class="iconHeaderClass"></i>
      <slot></slot>
    </h1>

    <notif-bar v-if="$route.name === 'home' "></notif-bar>

  </header>

</template>

<script>

import NotifBar from './NotifBar.vue'
import Config from '../../js/config'


if (Config.urlAPI !== 'https://api.fi360.fr' ){
    document.write("<div style='position: absolute; top: 20px; right: 40%; color: white; background-color: darkred; border: solid 1px; padding: 10px; font-weight: bold; border-radius: 20px'> DEV  <span style='font-size: 5px'>Geoloc</span></div>");
}
export default {

  methods: {
    openMenu : function () {
      document.getElementById('menu').className += ' open';
    }
  },

  props: {
    icon: {
      type: String,
      required: false,
      default: 'home'
    }
  },

  computed: {
    iconHeaderClass: function(){
      return 'icon-' + this.icon;
    },
    badgeCount() {
      return this.$root.badgeCount;
    }
  },

  components: {
    NotifBar
  }
}

</script>
<style>
.indicator {
  position: absolute;
  top: -10px; /* Adjusted for better vertical positioning */
  right: -10px; /* Adjusted for better horizontal positioning */
  width: 20px;
  height: 20px;
  background-color: red;
  border: 3px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noti_count {
  font-family: 'Montserrat', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  color: aliceblue;
  font-weight: 700;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// Header.vue?59185d46